import { NamedQuery } from '@ddv/models';

export function isAdditionalFilterNamesMatch(namedQueries: NamedQuery[]): boolean {
    const additionalFilterNameSignatures = namedQueries
        .map(getAdditionalFilterParameterNames)
        .filter((names) => names.length > 0)
        .map((names) => [...names].sort().join(','));

    return !(new Set(additionalFilterNameSignatures).size > 1);
}

function getAdditionalFilterParameterNames(namedQuery: NamedQuery): string[] {
    return (namedQuery.parameters ?? []).reduce((names: string[], parameter) => {
        if (parameter.type === 'additional-filter') {
            names.push(parameter.name);
        }
        return names;
    }, []);
}
